import { pgTable, serial, text, integer, numeric, timestamp, boolean, index } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const tendersTable = pgTable("tenders", {
  id: serial("id").primaryKey(),
  companyId: integer("company_id").notNull(),
  title: text("title").notNull(),
  governmentEntity: text("government_entity"),
  competitionNumber: text("competition_number"),
  sector: text("sector"),
  city: text("city"),
  deadline: timestamp("deadline"),
  bookletPrice: numeric("booklet_price", { precision: 12, scale: 2 }),
  tenderUrl: text("tender_url"),
  description: text("description"),
  status: text("status", {
    enum: ["new", "analyzing", "ready", "bid", "no_bid", "submitted", "lost", "won"],
  }).notNull().default("new"),
  hasAnalysis: boolean("has_analysis").notNull().default(false),
  vectorStoreId: text("vector_store_id"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
}, (table) => ({
  companyIdIdx: index("idx_tenders_company_id").on(table.companyId),
  statusIdx: index("idx_tenders_status").on(table.status),
  companyStatusIdx: index("idx_tenders_company_status").on(table.companyId, table.status),
  deadlineIdx: index("idx_tenders_deadline").on(table.deadline),
  companyDeadlineIdx: index("idx_tenders_company_deadline").on(table.companyId, table.deadline),
  createdAtIdx: index("idx_tenders_created_at").on(table.createdAt),
}));

export const insertTenderSchema = createInsertSchema(tendersTable).omit({ id: true, createdAt: true, updatedAt: true });
export type InsertTender = z.infer<typeof insertTenderSchema>;
export type Tender = typeof tendersTable.$inferSelect;
